module.exports = __webpack_public_path__ + "img/orc_tips@2x.f2f9b26d.png";